import { __assign, __spreadArray, __read } from 'tslib';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useListBoxSection } from 'react-aria';
import { Box } from '../../Box/index.js';
import { Divider } from './Divider.js';
import { Option } from './Option.js';

var Section = function (_a) {
    var section = _a.section, state = _a.state;
    var _b = useListBoxSection({
        heading: section.rendered,
        "aria-label": section["aria-label"],
    }), itemProps = _b.itemProps, headingProps = _b.headingProps, groupProps = _b.groupProps;
    return (jsx(Fragment, { children: jsx("li", __assign({}, itemProps, { children: jsxs(Box, __assign({ themeKey: "typeaheadSection" }, { children: [section.key !== state.collection.getFirstKey() && jsx(Divider, {}), jsx(Box, __assign({ themeKey: "typeaheadSectionHeading" }, headingProps, { children: section.rendered })), jsx(Divider, {}), jsx("ul", __assign({}, groupProps, { children: __spreadArray([], __read(section.childNodes), false).map(function (node) { return (jsx(Option, { item: node, state: state }, node.key)); }) }))] })) })) }));
};
Section.displayName = "Section";

export { Section };
//# sourceMappingURL=Section.js.map
